module.exports = __webpack_public_path__ + "img/background-layers-button-active.35c93399.svg";